<div *ngIf="!protectedMode || dataSourceFilesCreate.data.length > 0"    
    ngbDropdown placement="bottom" autoClose="outside" class="kt-header__topbar-item">
    <button 
        mat-icon-button        
        ngbDropdownToggle
        
        class="kt-header__topbar-wrapper"><!--[disabled]="!featureEnabled()"-->
        <span
            matTooltipDisabled="false"
            [matTooltip]="!featureEnabled()? ('FILEM.NO_ANSWERID' | translate) : ('FILEM.MASSIVE' | translate)"
            class="kt-header__topbar-icon" 
            [ngClass]="{'kt-pulse kt-pulse--brand': false, 'kt-pulse--light' : false, 'kt-header__topbar-icon--success' : false	}">
            <i *ngIf="!useSVG" [ngClass]="icon" class="icon-size"
                [matBadge]="dataSourceFilesCreate.data.length > 0? dataSourceFilesCreate.data.length : null "></i>
        </span>
    </button>

    <div ngbDropdownMenu 
        class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
        <form style="border-bottom: solid 1px #DEDEDE;">
            <!--begin: Head -->
            <!-- [ngStyle]="{'background-image': backGroundStyle() }" -->
            <div class="kt-head kt-head--skin-skin kt-head--fit-x kt-head--fit-b notification-header">
                <!--DRAG N DROP FILES-->
                <div class="kt-head__title">
                    <div *ngIf="!protectedMode && !isDetail"
                        class="uploadfilecontainer" 
                        appDragDrop 
                        (onFileDropped)="onFileUpload($event)"
                        (click)="fileInput.click()">
                        <input hidden type="file" multiple #fileInput (change)="onFileUpload($event.target.files)"/>
                            
                        <span class="logo-text h3">
                            
                            <div *ngIf="!spinnerDisplay">
                                <mat-icon class="md-24">cloud_upload</mat-icon>
                                {{'FILEM.MASSIVE' | translate}}
                            </div>

                            <div *ngIf="spinnerDisplay">
                                {{'FILEM.FILE_PROCESSING' | translate}} 
                                {{filesProcessed}}
                                {{'FILEM.FILE_OUTOF' | translate}} 
                                {{filesQueue}}
                                <mat-progress-spinner color="primary" mode="indeterminate" diameter="15" class="mx-12"></mat-progress-spinner>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
            <!--end: Head -->
            
            <div [perfectScrollbar]="{wheelPropagation: false}" [ngStyle]="{'max-height': '40vh', 'position': 'relative'}"
               class="kt-margin-t-10 kt-margin-b-10">
               <div class="files-table">
                        <mat-table #tableCreate [dataSource]="dataSourceFilesCreate">
                            <!-- icon Column -->
                            <ng-container matColumnDef="icon">
                                <mat-header-cell *matHeaderCellDef class="col-width-10"></mat-header-cell>
                                <mat-cell *matCellDef="let row" class="col-width-10" style="text-align: center;">
                                    <mat-icon 
                                     *ngIf="user.fullUserName === row.createUser || !row.createUser"
                                     [matTooltip]="'FILEM.TOOLTIP.FILE_OWNER' | translate"
                                     class="file-item">
                                         note_add
                                     </mat-icon>
                                    <mat-icon 
                                     *ngIf="user.fullUserName !== row.createUser && row.createUser"
                                     [matTooltip]="'FILEM.TOOLTIP.FILE_NOT_OWNER' | translate"
                                     class="file-item">
                                         insert_drive_file
                                     </mat-icon>
                                </mat-cell>
                            </ng-container>
     
                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef class="col-width-name">{{'FILEM.TABLE.NAME' | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" class="col-width-name download-item">
                                    <span (click)="getFileById(row.id, row.fileName)">
                                        {{ getFileName(row.fileName) }}
                                    </span>
                                </mat-cell>
                            </ng-container>
     
                            <!-- type Column -->
                            <ng-container matColumnDef="type">
                                <mat-header-cell *matHeaderCellDef class="d-none d-lg-table-cell col-width-20">{{'FILEM.TABLE.TYPE' | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" class="d-none d-lg-table-cell col-width-20"> {{ getFileExtension(row.fileName) }}</mat-cell>
                            </ng-container>
     
                            <!-- Size Column -->
                            <ng-container matColumnDef="size">
                                <mat-header-cell *matHeaderCellDef class="d-none d-lg-table-cell col-width-20">{{'FILEM.TABLE.SIZE' | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" class="d-none d-lg-table-cell col-width-20">{{row.fileSize === 0 ? '--': formatBytes(row.fileSize) }}</mat-cell>
                            </ng-container>
     
                            <ng-container matColumnDef="action">
                                <mat-header-cell *matHeaderCellDef class="col-width-15">{{'FILEM.TABLE.ACTION' | translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let row" class="col-width-15">
                                    <button
                                        *ngIf="(user.fullUserName === row.createUser || !row.createUser) && !isDetail"
                                         mat-icon-button
                                         [matTooltip]="'FILEM.TOOLTIP.DELETE' | translate"
                                         matTooltipPosition="above"
                                         (click)="dropFileCreate(row)">
                                         <mat-icon class="drop_row">
                                             close
                                         </mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>
     
                            <ng-container matColumnDef="noRecord">
                                <mat-footer-cell *matFooterCellDef>
                                    <div style="width: 100%;text-align: center;">{{'FILEM.TABLE.EMPTY' | translate}}</div>
                                </mat-footer-cell>
                            </ng-container>
     
                            <!-- [@animate]="{value:'*',params:{y:'100%'}} -->
                            <mat-header-row *matHeaderRowDef="displayedFilesColumns;"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedFilesColumns;"></mat-row>
     
                            <mat-footer-row 
                                *matFooterRowDef="['noRecord']"
                                [hidden]="dataSourceFilesCreate.data.length > 0">
                            </mat-footer-row>
                        </mat-table>
                   
               </div>
               <div class="ps__rail-y" style="top: 0px; right: 0px;">
                   <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
               </div>
           </div>		
        </form>
    </div>
</div>




